
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import LeaveRequestDocumentSerializer from '../types/LeaveRequestDocumentSerializer_apps_HRM'


const HOST = `${config.API_HOST}`
/* ['generics.CreateAPIView'] */
/* params:  */
/* data:  */
const LeaveRequestDocumentList : 
{
  create:   ({params, data, apiToken, extra}:
             { 
                params?: any,
                data?: Partial<LeaveRequestDocumentSerializer>,
                apiToken?: any,
                extra?: any
            }) => any,
} = 
{
  create: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
      base.client.defaults.headers["content-type"] = "multipart/form-data";
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const formData = new FormData();

    if (data?.leave_request) {
      formData.append("leave_request", data.leave_request);
    }

    data?.items?.forEach((item, index) => {
      if (item.id) {
        formData.append(`items[${index}].id`, item.id);
      }
      formData.append(`items[${index}].file`, item.file);
    });

    // log
    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    const result = await to(base.client.post(`${HOST}/apis/HRM/leave-request-document/`,
      formData,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default LeaveRequestDocumentList

